// extracted by mini-css-extract-plugin
export var container = "_d1-0";
export var popoverContent = "_d1-1";
export var tosLink = "_d1-2";